import { Box, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { getCommonTransition } from "../../../utils/mui";
import { ComponentType, JourneyAnchors } from "../../../constants";
import SidebarTemplateContent from "./SidebarTemplateContent";
import { useTemplateSidebar } from "../../../contexts/TemplateSidebarContext";
import { ComponentTemplateDto } from "@growth-machine-llc/stridist-api-client";

export const TEMPLATE_SIDEBAR_WIDTH = 324;
export const TEMPLATE_SIDEBAR_HEADING_HEIGHT = 35;
export const TEMPLATE_SIDEBAR_BOTTOM_NAVIGATION_HEIGHT = 56;

interface ISidebarTemplateProps {
  content: ComponentTemplateDto;
  type: ComponentType;
}

const COMPONENT_ID = "template-sidebar-container";

const SidebarTemplate = (props: ISidebarTemplateProps) => {
  const { isOpen } = useTemplateSidebar();
  const { content, type } = props;
  const theme = useTheme();
  const [maxHeight, setMaxHeight] = useState<"unset" | number>("unset");

  const SIDEBAR_MARGIN = 4;
  const SIDEBAR_MARGIN_INT_VALUE = parseInt(theme.spacing(SIDEBAR_MARGIN));

  //
  //
  // RESIZE ON SCROLL

  useEffect(() => {
    const handleScroll = () => {
      // get element
      const element = document.getElementById(COMPONENT_ID);

      if (element) {
        // calc max height based on space to top include margins
        const { top } = element.getBoundingClientRect();
        const maxHeight = window.innerHeight - top - SIDEBAR_MARGIN_INT_VALUE;

        // prevent overflow
        if (window.innerHeight - 2 * SIDEBAR_MARGIN_INT_VALUE > maxHeight) {
          setMaxHeight(maxHeight);
        }
      }
    };

    // init calculation
    handleScroll();

    // event listeners
    document?.getElementById("root")?.addEventListener("scroll", handleScroll);
    return () =>
      document
        ?.getElementById("root")
        ?.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Box
      className={JourneyAnchors.COMPONENT_TEMPLATE_SIDEBAR}
      id={COMPONENT_ID}
      sx={{
        display: "flex",
        flexDirection: "column",
        overflowY: "hidden",
        position: "sticky",

        height: "unset",
        width: TEMPLATE_SIDEBAR_WIDTH,
        minHeight: 600,
        maxHeight: maxHeight,
        maxWidth: TEMPLATE_SIDEBAR_WIDTH,
        top: theme.spacing(4),
        zIndex: isOpen ? theme.zIndex.appBar : theme.zIndex.speedDial,

        marginTop: SIDEBAR_MARGIN,
        marginBottom: SIDEBAR_MARGIN,
        marginLeft: "auto",

        borderRadius: 2,
        border: 1,
        borderColor: theme.palette.divider,
        background: theme.palette.common.white,

        opacity: isOpen ? 1 : 0,
        transition: getCommonTransition(theme, ["opacity", "max-height"]),
      }}
    >
      <SidebarTemplateContent componentTemplate={content} type={type} />
    </Box>
  );
};

export default SidebarTemplate;
